<template id="checkout-card-template">
    <div class="payment-profile row" style="cursor: pointer; border-bottom:1px solid #e7e7e7;" @click="select( payment_profile_id )" :class=" {'selected': isActiveCard}">
        <div class="col-sm-1 status text-uppercase" >
            <span>
                <i class="fa fa-square-o m-r-5" v-if="!isActiveCard"></i>
                <i class="fa fa-check-square m-r-5" style="color:#4caf50;" v-else></i>
            </span>
        </div>
        <div class="col-sm-4 card-number text-uppercase" :class="{ 'text-bold':isActiveCard }">
            <i class="m-r-10 fa fa-2x" :class="iconClass()"></i>
            {{ card_number }}
        </div>
        <div class="col-sm-3 card-exp text-uppercase" :class="{ 'text-bold':isActiveCard }">EXP: {{ expiration }}</div>

        <div class="col-md-4 card-actions">
            <div class="btn-group pull-right">
                <button type="button" class="btn btn-danger remove-card"  @click="remove"><i class="fa fa-trash"></i> Remove Card</button>
            </div>
        </div>
    </div>
</template>
<style lang="scss">

    @import '../../sass/_global_variables.scss';

    #payment-profiles-list{
        .payment-profile{
            padding-top:20px;
            padding-left:10px;
            padding-bottom:20px;
            padding-right: 10px;
            margin-left:0px;
            margin-right:0px;
            &.selected{
                background : #d9e8e2;
                /*background : #dff0d8;*/
            }
            &:hover{
                background : darken(#d9e8e2, 5%);
            }
            .status .active-card{
                font-weight: 700;
            }
            .status a{
                cursor: pointer;
            }
            i.fa {
                vertical-align: middle;
            }
        }
        .add-new-card {
            padding-top:20px;
            padding-left:10px;
            padding-bottom:20px;
            padding-right: 10px;
            margin-left:0px;
            margin-right:0px;
        }
    }

</style>
<script type="text/ecmascript-6">
    export default{
        props: ['payment_profile_id','selected_payment_profile','card_number','card_type','expiration'],
        data(){
            return{}
        },
        methods: {
            iconClass () {
                switch (this.card_type.toLowerCase()) {
                    case 'visa':
                        return 'fa-cc-visa';
                        break;
                    case 'mastercard':
                        return 'fa-cc-mastercard';
                        break;
                    case 'discover':
                        return 'fa-cc-discover';
                        break;
                    case 'americanexpress':
                        return 'fa-cc-amex';
                        break;
                    default:
                        return 'fa-credit-card'
                }
            },
            toggleCard: function() {
                if (this.is_activeCard) {
                    this.isActiveCard = false;
                }
                else {
                    this.$emit('select', payment_profile_id );
                }
            },
            select ( payment_profile_id ) {
                // Propogate an event up to the main app so we know the active card has changed
                this.$emit('select', payment_profile_id );
            },
            remove () {
                this.$emit('remove', this.payment_profile_id, this.card_type);
            }
        },
        computed: {
            isActiveCard () {
                if (this.payment_profile_id == this.selected_payment_profile) {
                    return true;
                }else{
                    return false;
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// checkout-card.vue?2fb490ed